import { Customer } from '@tcs/create-account/types/Customer';
import { useQuery } from './useQuery';

const useCustomer = (enabled?: boolean) => {
  const { data, isLoading: loading } = useQuery<Customer, Error>(`pardot`, {
    enabled,
  });

  return {
    loading,
    data,
  };
};

export default useCustomer;
